import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="FCPS sports programs and events" 
          className="hero-image" 
        />
        <p className="eyebrow">FCPS Sports Coverage</p>
        <h1>Welcome to FCPS Sports!</h1>
        <p className="lede">
          Your go-to source for the latest sports events, teams, and news from Fairfax County Public Schools. Stay updated and engaged with our community.
        </p>
        <div className="cta-row">
          <a href="/events" target="_self">
            View Upcoming Events
          </a>
          <a href="/teams" target="_self" className="secondary">
            Explore Our Teams
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Stay Informed</h2>
          <p>
            Get the latest updates on games, scores, and highlights from all FCPS sports teams.
          </p>
        </article>
        <article>
          <h2>Join the Community</h2>
          <p>
            Connect with fellow fans, athletes, and families to support our local teams and events.
          </p>
        </article>
        <article>
          <h2>Celebrate Achievements</h2>
          <p>
            Discover stories of excellence and sportsmanship from our student-athletes and teams.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;